<template>
    <div id="DemoFormViews">
        <h3 style="text-align: center">Kayıt Olurken işaretlediği özellikler görüntülenir</h3>
        <hr>
        <div style="display: flex;justify-content: space-between;">
            <div class="page-one">
                <h5 style="text-align: center;padding: 20px;">Purpose Usage</h5>
                <div class="container">
                    <h3 class="sup-title">Supsis'i Ne için Kullanacaksın?</h3>
                    <div id="CheckboxOne" class="page-one-content">
                        <div>
                            <img src="https://widget.supsis.live/style/icon/ChatbotIcon.png" alt="chatbot" />
                        </div>
                        <div class="pageTwo-title">
                            <h5 class="sup-title">ChatBot</h5>
                            <p>Yenilikçi chatbotumuz, kullanıcılarla akıllıca
                                etkileşim kurar
                                ve anlık çözümler sunarak
                                müşteri deneyimini üst seviyeye taşır.</p>
                        </div>
                        <div>
                            <label class="ls-checkbox-container">
                                <input
                                    type="checkbox"
                                    id="chatbot"
                                    name="chatbot"
                                    value="chatbot"
                                    v-model="selectedOptions"
                                    :disabled="true"
                                >
                                <span class="ls-checkbox-checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div id="CheckboxTwo" class="page-one-content">
                        <div>
                            <img src="https://widget.supsis.live/style/icon/AiIcon.png" alt="chatbot" />
                        </div>
                        <div class="pageTwo-title">
                            <h5 class="sup-title">AI Asistan</h5>
                            <p>Yapay zeka destekli asistanımız, müşteri
                                taleplerini
                                anında
                                karşılar ve
                                müşteri memnuniyetini artırır.</p>
                        </div>
                        <div>
                            <label class="ls-checkbox-container">
                                <input
                                    type="checkbox"
                                    id="aiAsistan"
                                    name="aiAsistan"
                                    value="aiAsistan"
                                    v-model="selectedOptions"
                                    :disabled="true"
                                >
                                <span class="ls-checkbox-checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div id="CheckboxThree" class="page-one-content">
                        <div style="width: 77px">
                            <img src="https://widget.supsis.live/style/icon/ChatBalloonIcon.png" alt="chatbot" />
                        </div>
                        <div class="pageTwo-title">
                            <h5 class="sup-title">Canlı Destek</h5>
                            <p>Müşteri temsilcilerinizle anlık görüşmeler
                                yaparak
                                müşteri
                                memnuniyetini artırın.</p>
                        </div>
                        <div>
                            <label class="ls-checkbox-container">
                                <input
                                    type="checkbox"
                                    id="livesupport"
                                    name="livesupport"
                                    value="livesupport"
                                    v-model="selectedOptions"
                                    :disabled="true"
                                >
                                <span class="ls-checkbox-checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-two">
                <h5 style="text-align: center;padding: 20px;"> Request Chackbox</h5>
                <div class="container">
                    <h3 class="sup-title">Hangi modülleri kullanmak istiyorsunuz?</h3>
                    <div v-if="pageOne">
                        <div id="CheckboxFour" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/WhatsappIcon.png" alt="WhatsappIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Toplu Whatsapp ve Mesaj Yönetimi</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="bulkWhatsappMessageManagement"
                                        type="checkbox"
                                        name="bulkWhatsappMessageManagement"
                                        value="bulkWhatsappMessageManagement"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxFive" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/ChatbotIconAI.png" alt="ChatbotAI"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Dinamik Yapay Zeka ve Chatbot</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="dynamicArtificialIntelligenceAndChatbot"
                                        type="checkbox"
                                        name="dynamicArtificialIntelligenceAndChatbot"
                                        value="dynamicArtificialIntelligenceAndChatbot"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxSix" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/VideoCallIcon.png" alt="chatbot"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Görüntülü ve Sesli Görüşme</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="videoAndVoiceCall"
                                        type="checkbox"
                                        name="videoAndVoiceCall"
                                        value="videoAndVoiceCall"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxSeven" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/MailIcon.png" alt="chatbot"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Mail Yönetimi ve CRM</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="mailManagementAndCRM"
                                        type="checkbox"
                                        name="mailManagementAndCRM"
                                        value="mailManagementAndCRM"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="pageTwo">
                        <div id="CheckboxEight" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/WebSiteIcon.png" alt="WebSiteIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Web Site Analiz ve Segmentasyon</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="websiteAnalysisAndSegmentation"
                                        type="checkbox"
                                        name="websiteAnalysisAndSegmentation"
                                        value="websiteAnalysisAndSegmentation"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxNine" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/TranslateIcon.png" alt="TransLateIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Her Dilde Çeviri</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="translationInEveryLanguage"
                                        type="checkbox"
                                        name="translationInEveryLanguage"
                                        value="translationInEveryLanguage"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxTen" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/TriggerIcon.png" alt="TriggerIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Tetikleyiciler</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="triggers"
                                        type="checkbox"
                                        name="triggers"
                                        value="triggers"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxEleven" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/ReportIcon.png" alt="chatbot"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Gelişmil Raporlama</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="advancedReporting"
                                        type="checkbox"
                                        name="advancedReporting"
                                        value="advancedReporting"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="pageThree">
                        <div id="CheckboxTwelve" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/AiIcon.png" alt="WebSiteIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Yapay Zeka Asistan</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="artificialIntelligenceAssistant"
                                        type="checkbox"
                                        name="artificialIntelligenceAssistant"
                                        value="artificialIntelligenceAssistant"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxThirteen" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/teamIcon.png" alt="WebSiteIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Şirket İçi İletişim</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="internalCommunication"
                                        type="checkbox"
                                        name="internalCommunication"
                                        value="internalCommunication"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxFourteen" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/CRMicon.png" alt="WebSiteIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>CRM ve İş Yönetim Sistemi</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="crmAndBusinessManagementSystem"
                                        type="checkbox"
                                        name="crmAndBusinessManagementSystem"
                                        value="crmAndBusinessManagementSystem"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div id="CheckboxFifteen" class="page-three-content">
                            <div class="sup-margin-top-30">
                                <img src="https://widget.supsis.live/style/icon/calendarIcon.png" alt="WebSiteIcon"
                                     class="sup-img-width" />
                            </div>
                            <div class="pageThree-text">
                                <p>Otomatik Rezervasyon Sistemi</p>
                            </div>
                            <div>
                                <label class="ls-checkbox-container">
                                    <input
                                        id="automaticReservationSystem"
                                        type="checkbox"
                                        name="automaticReservationSystem"
                                        value="automaticReservationSystem"
                                        v-model="selectedOptionsTwo"
                                        :disabled="true"
                                    >
                                    <span class="ls-checkbox-checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div id="pageThreeFooter">
                        <div class="page-footer-back-btn">
                            <div class="sup-back-btn" id="backBtnOne" @click="backBtn"><</div>
                        </div>
                        <div class="sup-page-round">
                            <div class="page-round-item page-round-item-active" id="pageRoundOne"></div>
                            <div class="page-round-item" id="pageRoundTwo"></div>
                            <div class="page-round-item" id="pageRoundThree"></div>
                        </div>
                        <div class="page-footer-next-btn">
                            <div class="sup-next-btn" id="nextBtnOne" @click="nexBtn">></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
    name: "DemoFormViews",
    props: {
        siteId: {
            type: String,
            required: true,
        },
        siteData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            pageOne: true,
            pageTwo: false,
            pageThree: false,
            selectedOptions: this.siteData.demoRequestOptions.purposeUsage,
            selectedOptionsTwo: this.siteData.demoRequestOptions.requestCheckbox,
        };
    },
    methods: {
        ...mapActions({
            getSites: "site/getSite",
        }),
        nexBtn() {
            if (this.pageOne === true) {
                this.pageOne = false;
                this.pageTwo = true;
                this.pageThree = false;
                document.getElementById("pageRoundOne").classList.remove("page-round-item-active");
                document.getElementById("pageRoundTwo").classList.add("page-round-item-active");
                document.getElementById("pageRoundThree").classList.remove("page-round-item-active");
            } else if (this.pageTwo === true) {
                this.pageOne = false;
                this.pageTwo = false;
                this.pageThree = true;
                document.getElementById("pageRoundOne").classList.remove("page-round-item-active");
                document.getElementById("pageRoundTwo").classList.remove("page-round-item-active");
                document.getElementById("pageRoundThree").classList.add("page-round-item-active");
            }
        },
        backBtn() {
            if (this.pageTwo === true) {
                this.pageOne = true;
                this.pageTwo = false;
                this.pageThree = false;
                document.getElementById("pageRoundOne").classList.add("page-round-item-active");
                document.getElementById("pageRoundTwo").classList.remove("page-round-item-active");
                document.getElementById("pageRoundThree").classList.remove("page-round-item-active");
            } else if (this.pageThree === true) {
                this.pageOne = false;
                this.pageTwo = true;
                this.pageThree = false;
                document.getElementById("pageRoundOne").classList.remove("page-round-item-active");
                document.getElementById("pageRoundTwo").classList.add("page-round-item-active");
                document.getElementById("pageRoundThree").classList.remove("page-round-item-active");
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#DemoFormViews {
    .container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        background: #f8fcfe;
        width: 500px;
        padding: 20px;
        border-radius: 20px;
    }

    .sup-title {
        text-align: left;
        color: #162c4a;
    }

    .page-one-content {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 50px;
        margin-top: 20px;
        cursor: pointer;
    }
    .page-one {
        .page-one-content img {
            width: 100px;
        }
        .pageTwo-title {
            margin-left: -40px;
            padding-top: 20px
        }
    }

    .page-two {
        .page-three-content {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        #pageThreeFormTwo {
            display: none;
        }

        #pageThreeFromThree {
            display: none;
        }

        .sup-margin-top-30 {
            margin-top: 30px;
        }

        .page-three-content {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        .sup-img-width {
            width: 30px;
        }

        .page-three-content img {
            margin-right: 10px;
        }

        .page-three-content .pageThree-text {
            flex-grow: 1;
        }

        .pageThree-text {
            margin-top: 40px
        }

        .pageThree-text p {
            text-align: left;
            font-size: 17px;
        }

        .sup-page-round {
            display: flex;
            gap: 3px;
        }

        #pageThreeFooter {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            align-items: center;
            gap: 5px;
        }

        .sup-next-btn {
            background: transparent;
            border: transparent;
            color: #d9d9d9;
            font-size: 20px;
            font-family: math;
            cursor: pointer;
        }

        .sup-back-btn {
            background: transparent;
            border: transparent;
            color: #d9d9d9;
            font-size: 20px;
            font-family: math;
            cursor: pointer;
        }

        .page-round-item {
            background: #d9d9d9;
            border-radius: 50px;
            width: 8px;
            height: 8px;
        }

        .page-round-item-active {
            background: #162c4a !important;
        }
    }
    .ls-checkbox-container {
        display: inline-block;
        position: relative;
        padding-left: 45px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .ls-checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .ls-checkbox-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 30px;
        width: 30px;
        background-color: #e1e1ec;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ls-checkbox-container:hover input ~ .ls-checkbox-checkmark {
        background-color: #ccc;
    }

    .ls-checkbox-container input:checked ~ .ls-checkbox-checkmark {
        background-color: #4a1fc2;
        border-radius: 8px;
    }

    .ls-checkbox-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .ls-checkbox-container input:checked ~ .ls-checkbox-checkmark:after {
        display: block;
    }

    .ls-checkbox-container .ls-checkbox-checkmark:after {
        width: 14px;
        height: 8px;
        border: solid white;
        border-width: 0 0 2px 2px;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(315deg);

    }
}
</style>
